import { message } from 'ant-design-vue';
import { language } from '@/config/const';
export const getUrlParams = url => {
    // 通过 ? 分割获取后面的参数字符串
    url = url.replace(/\"|\'/g, '');
    url = url.split('?');
    if (url.length <= 1) {
        return {};
    }
    let urlStr = url[1];
    // 创建空对象存储参数
    let obj = {};
    // 再通过 & 将每一个参数单独分割出来
    let paramsArr = urlStr.split('&');
    for (let i = 0, len = paramsArr.length; i < len; i++) {
        // 再通过 = 将每一个参数分割为 key:value 的形式
        let arr = paramsArr[i].split('=');
        obj[arr[0]] = arr[1];
    }
    return obj;
};

// 因为默认没有路由，故拿不到路由中的参数，需要动态获取
export const getHashParams = type => {
    let hash = window.location.hash;
    hash = hash.split('?');
    hash = hash[0];
    hash = hash.split('/');

    let cnIndex = 0;
    hash.forEach((it, idx) => {
        // 证明已找到语言
        if (language[it]) {
            cnIndex = idx;
        }
    });
    if (type == 'lang') {
        return hash[cnIndex] || '';
    }
    if (type == 'meeting_id') {
        return hash[cnIndex + 1] || '';
    }
    if (type == 'forum_id') {
        return hash[cnIndex + 2] || '';
    }
    return '';
};

export const copy = value => {
    var input = document.createElement('input');
    input.value = value;
    document.body.appendChild(input);
    input.select();
    document.execCommand('copy');
    message.success(window.$i18n.t('web.copy_success' /* 复制成功 */));
    document.body.removeChild(input);
};
